var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"img",style:(_vm.imgStyle),attrs:{"src":_vm.src,"alt":_vm.info.name},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }